import { render, staticRenderFns } from "./mixtmt_pagination.vue?vue&type=template&id=b2672e2a"
import script from "./mixtmt_pagination.vue?vue&type=script&lang=js"
export * from "./mixtmt_pagination.vue?vue&type=script&lang=js"
import style0 from "./mixtmt_pagination.vue?vue&type=style&index=0&id=b2672e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports